<template>
    <div class="d-flex w-100 gap-20">
        <div class="box" :class="renderSimilarityClass(similarity)" v-if="response.method === 'Structural Similarity Index Measure'">
            <strong>{{ translate('Similarity')}}</strong>
            <strong>{{ similarity }}%</strong>
        </div>

        <div class="box" :class="renderDifferenceClass(percentDiff)" v-else>
            <strong>{{ translate('Difference')}}</strong>
            <strong>{{ percentDiff }}%</strong>
        </div>

        <table class="table bg-white table-bordered m-0">
            <thead class="thead-light">
                <tr>
                    <th>{{ translate('Method') }}</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>{{ response.method }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
import { translate } from '../../../../../../../helper/translate';
export default {
    name: 'ImageMethodDifference',
    props: {
        response: Object,
        factors: Object,
        percentDiff: String,
    },
    computed: {
        similarity() {
            return (this.factors.all * 100).toFixed(2);
        },
    },
    methods: {
        renderDifferenceClass(factor) {
            if (factor < 20) {
                return 'green-box';
            } else if (factor >= 20 && factor <= 40) {
                return 'yellow-box';
            } else {
                return 'red-box';
            }
        },
        renderSimilarityClass(factor) {
            if (factor < 60) {
                return 'red-box';
            } else if (factor >= 60 && factor <= 80) {
                return 'yellow-box';
            } else {
                return 'green-box';
            }
        }
    }
};
</script>
<style scoped lang="scss">
.box {
    display: flex;
    padding: 5px 40px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 5px;
    align-self: stretch;
    border-radius: 4px;
}
.yellow-box {
    color: #8F6C25;
    border: 1px solid #8F6C25;
    background: #FFF1D6;
}
.green-box {
    color: #0B7335;
    border: 1px solid #0B7335;
    background: #CCF4DC;
}
.red-box {
    color: #8F2E2E;
    border: 1px solid #8F2E2E;
    background: #FFDADA;
}
</style>
